import React, { PureComponent } from 'react';
// import PropTypes from 'prop-types';
import { StyledModal, StyledSearchFilterButton } from './style';
import FilterFormMini from './FilterFormMini';

const txtBtnFilter = 'Modificar filtros';
const txtBtnNoFilters = 'Buscar y filtrar';

class SearchFilterMini extends PureComponent {
  render() {
    const {
      onClick,
      closeModal,
      openModal,
      modalActive,
      filter,
      setFilter
    } = this.props;
    return (
      <div>
        {modalActive ? (
          <StyledModal title="Seleccionar filtros" clickCloseIcon={closeModal}>
            <FilterFormMini
              onClick={onClick}
              closeModal={closeModal}
              modalActive={modalActive}
              filter={filter}
              setFilter={setFilter}
            />
          </StyledModal>
        ) : (
          <React.Fragment>
            <FilterFormMini
              onClick={onClick}
              modalActive={modalActive}
              filter={filter}
              setFilter={setFilter}
            />
            <StyledSearchFilterButton
              onClick={openModal}
              modalActive={modalActive}
            >
              {Object.keys(filter).length > 0 ? txtBtnFilter : txtBtnNoFilters}
            </StyledSearchFilterButton>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default SearchFilterMini;
